import { render, staticRenderFns } from "./CodeDemo.vue?vue&type=template&id=b01f227e&scoped=true&"
import script from "./CodeDemo.vue?vue&type=script&lang=js&"
export * from "./CodeDemo.vue?vue&type=script&lang=js&"
import style0 from "./CodeDemo.vue?vue&type=style&index=0&id=b01f227e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f227e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01f227e')) {
      api.createRecord('b01f227e', component.options)
    } else {
      api.reload('b01f227e', component.options)
    }
    module.hot.accept("./CodeDemo.vue?vue&type=template&id=b01f227e&scoped=true&", function () {
      api.rerender('b01f227e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/CodeDemo.vue"
export default component.exports